import styles from './vimeo-embed.module.less';

const getVimeoVideoIdFromUrl = (url) => {
    const regExp = /^.*(vimeo\.com\/)((channels\/[A-z]+\/)|(groups\/[A-z]+\/videos\/))?([0-9]+)/;
    const match = regExp.exec(url);
    return match[5];
};

const objectToQueryString = (obj) => {
    const params = Object.entries(obj).map(([k, v]) => `${k}=${v}`);
    return params.join('&');
};

export default function VimeoEmbed({
    title,
    url,
    margins = false,
    autoplay = false,
    loop = false,
    background = false,
    aspectRatio = '16 / 9',
}) {
    if (!url) {
        return <></>;
    }
    const queryParams = {
        badge: '0',
        player_id: '0',
        app_id: '58479',
        loop: loop ? '1' : '0',
        autoplay: autoplay ? '1' : '0',
        background: background ? '1' : '0',
    };
    const vimeoId = getVimeoVideoIdFromUrl(url);
    return (
        <div className={[styles.vimeoEmbedContainer, margins ? styles.vimeoMargins : undefined].join(' ')}>
            <iframe
                src={`https://player.vimeo.com/video/${vimeoId}?${objectToQueryString(queryParams)}`}
                frameBorder="0"
                allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media"
                title={title || 'Vimeo video'}
                style={{ aspectRatio }}
            ></iframe>
        </div>
    );
}
